export default {
  dashboard: "داشبورد",
  perfectMoney: {
    mainTitle: "پرفکت مانی",
    buy: "خرید پرفکت‌مانی",
    sell: "فروش پرفکت‌مانی"
  },
  order: "سفارش گذاری",
  orderProcess: {
    depositProcess: "واریز",
    offlineDepositProcess: "واریز",
    depositResubmitProcess: "کیف پول‌ها",
    withdrawalProcess: "برداشت",
    withdrawalRialProcess: "برداشت",
    withdrawalCryptoProcess: "برداشت",
    exchangeProcess: "تبدیل",
    transferProcess: "انتقال"
  },
  walletOrder: "کیف پول‌ها",
  wallet: {
    main: "کیف پول اصلی",
    spot: "کیف پول اسپات"
  },
  tickets: {
    mainTitle: "تیکت‌ ها",
    createTicket: "تیکت‌ ها",
    singleTicket: "تیکت‌ ها",
    ticketList: "تیکت‌ ها"
  },
  gifts: "هدایا",
  referral: "دعوت از دوستان",
  operations: {
    deposit: "کیف پول‌ها",
    withdrawal: "کیف پول‌ها",
    exchange: "تبدیل",
    transfer: "کیف پول‌ها"
  },
  transactionOrder: {
    deposits: "تاریخچه تراکنش‌ها",
    withdrawals: "تاریخچه تراکنش‌ها",
    exchanges: "تاریخچه تراکنش‌ها",
    transfers: "تاریخچه تراکنش‌ها"
  },
  account: "تنظیمات حساب",
  Markets: {
    market: "بازارها"
  },
  history: {
    ordersHistory: "تاریخچه سفارشات",
    preconditionOrdersHistory: "تاریخچه حد سود و ضرر",
    transactions: "تراکنش‌ها"
  },
  staking: {
    mainTitle: "استخرهای مشارکت و استیکینگ"
  }
};
